<script>
  import { mapState, mapActions } from 'vuex'
  import { animationMixin } from './mixin'
  import NavigationCollapsedItem from './NavigationCollapsedItem'
  import NavigationItem from './NavigationItem'
  import NavigationItemChild from './NavigationItemChild'

  export default {
    name: 'navigation',

    components: {
      NavigationCollapsedItem,
      NavigationItem,
      NavigationItemChild
    },

    mixins: [animationMixin],

    props: {
      items: {
        type: Array,
        required: true
      },
      showChildren: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        collapsedItem: null,
        collapsedItemPos: 0,
        collapsedItemHeight: 0,
        closeTimeout: null
      }
    },

    computed: {
      ...mapState('navigation', {
        isCollapsed: state => state.isCollapsed
      })
    },

    created () {
      this.$on('mouseEnterItem', (val) => {
        this.collapsedItem = null
        this.$nextTick(() => {
          this.collapsedItem = val.item
          this.collapsedItemPos = val.pos
          this.collapsedItemHeight = val.height
        })
      })

      this.$on('touchClickItem', (clearCloseTimeout) => {
        if (clearCloseTimeout) {
          clearTimeout(this.closeTimeout)
          return
        }
        if (this.closeTimeout) clearTimeout(this.closeTimeout)
        this.closeTimeout = setTimeout(() => {
          this.mouseLeave()
        }, 600)
      })
    },

    methods: {
      ...mapActions('navigation', ['toggleCollapse']),

      mouseLeave () {
        this.collapsedItem = null
      }
    },
    provide () {
      return {
        showChildren: this.showChildren
      }
    }
  }
</script>

<template>
  <div class="navigation" :class="[!isCollapsed ? 'opened' : 'collapsed']" @mouseleave="mouseLeave">
    <div class="logo">
      <slot name="logo"></slot>
    </div>

    <div class="menu">
      <template v-for="(item, index) in items">
        <template v-if="item.header">
          <template v-if="(item.visibleOnCollapse || !isCollapsed) && item.component">
            <component :is="item.component" :key="index"/>
          </template>

          <template v-else-if="item.visibleOnCollapse || !isCollapsed">
            <div :key="index" class="menu-header">
              {{ item.title }}
            </div>
          </template>
        </template>

        <navigation-item v-else :key="index" :item="item" :first-item="true"/>
      </template>
    </div>

    <div class="collapsed-items" v-if="isCollapsed" :style="[{'top' : `${collapsedItemPos}px`}]">
      <navigation-collapsed-item :item="collapsedItem"/>
      <div v-if="collapsedItem" class="menu-collapsed-item" :style="[{'height' : `${collapsedItemHeight}px`}]"></div>

      <div class="menu-dropdown"
           :style="[{'top' : `${collapsedItemHeight}px`}, {'max-height' : `calc(100vh - ${collapsedItemPos + collapsedItemHeight}px)`}]">
        <transition name="expand" @enter="expandEnter" @afterEnter="expandAfterEnter" @beforeLeave="expandBeforeLeave">
          <div v-if="collapsedItem && collapsedItem.children" class="menu">
            <navigation-item-child v-for="(child, index) in collapsedItem.children" :key="index" :item="child"/>
          </div>
        </transition>
      </div>
    </div>

    <button class="collapse-btn" @click="toggleCollapse">
      <font-awesome-icon :icon="['far', (isCollapsed) ? 'arrow-right' : 'arrow-left']"/>
    </button>
  </div>
</template>

<style src="./Navigation.scss" lang="scss"></style>
